// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartCommonActionPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import EventUtils from 'EventUtils';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { get } from 'lodash/fp';

const ChartCommonActionPopup = props => {
  const fieldConfig = props.fieldConfig;
  const subReport = get('subReport', fieldConfig);
  const customURL = get('customURL', fieldConfig);
  const embeddedJavascript = get('embeddedJavascript', fieldConfig);
  const localization = props.localization;

  return (
    <Popup visible onClosed={handleClosed} type="none" sizeClass="modal-sm">
      <Popup.Header title={localization.getText('REPORTDESIGNER_LABEL_OPEN_ACTIONS')} />
      <Popup.Body>{renderContainer(localization)}</Popup.Body>
    </Popup>
  );

  function handleClosed(type) {
    props.onAccept();
  }

  function renderContainer(localization) {
    return (
      <GridLayout>
        {get('selectedReport', subReport) ? (
          <GridLayout.Row>
            <GridLayout.Col cols={1}>
              {get('viewSettingByLink', subReport) ? null : (
                <span className={get('selectedIconValue.icon', subReport)} />
              )}
            </GridLayout.Col>
            <GridLayout.Col cols={11}>
              <a onClick={handleOpenSubReport}>{localization.getText('REPORTDESIGNER_LABEL_OPEN_SUBREPORT')}</a>
            </GridLayout.Col>
          </GridLayout.Row>
        ) : null}
        {get('url', customURL) ? (
          <GridLayout.Row>
            <GridLayout.Col cols={1}>
              {get('viewSettingByLink', customURL) ? null : (
                <span className={get('selectedIconValue.icon', customURL)} />
              )}
            </GridLayout.Col>
            <GridLayout.Col cols={11}>
              <a onClick={handleOpenLink}>{localization.getText('REPORTDESIGNER_LABEL_OPEN_LINK')}</a>
            </GridLayout.Col>
          </GridLayout.Row>
        ) : null}
        {get('script', embeddedJavascript) ? (
          <GridLayout.Row>
            <GridLayout.Col cols={1}>
              {get('viewSettingByLink', embeddedJavascript) ? null : (
                <span className={get('selectedIconValue.icon', embeddedJavascript)} />
              )}
            </GridLayout.Col>
            <GridLayout.Col cols={11}>
              <a onClick={handlePerformAction}>{localization.getText('REPORTDESIGNER_LABEL_PERFORM_ACTION')}</a>
            </GridLayout.Col>
          </GridLayout.Row>
        ) : null}
      </GridLayout>
    );
  }

  function handleOpenSubReport() {
    props.onAccept('openSubReport');
  }

  function handleOpenLink() {
    props.onAccept('openCustomURL');
  }

  function handlePerformAction() {
    props.onAccept('performEmbeddedJavascript');
  }
};

ChartCommonActionPopup.propsType = {
  fieldConfig: React.PropTypes.object
};

export default connect()(ChartCommonActionPopup);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartCommonActionPopup.js